"use client";
'use strict';

var cookies = require('js-cookie');
var React = require('react');
var designSystemTheme = require('@sravni/design-system-theme');
var consts = require('@sravni/utils/lib/consts');
var theme = require('@sravni/utils/lib/theme');
var consts$1 = require('../providers/ThemeProvider/consts.js');
var useTheme = require('./useTheme.js');

const darkThemeExpression = '(prefers-color-scheme: dark)';
const setSystemCookie = (isDarkTheme) => {
    cookies.set(consts.COOKIES.SYSTEM_THEME, isDarkTheme ? designSystemTheme.ThemeName.guinness : designSystemTheme.ThemeName.lager, {
        expires: new Date(new Date().getTime() + consts$1.COOKIE_MAX_AGE),
        sameSite: 'Lax',
        path: '/',
    });
};
const isValidThemeName = (value) => [designSystemTheme.ThemeName.lager, designSystemTheme.ThemeName.guinness].includes(value);
/**
 * Следит за текущей темой браузера. При изменении вызывает изменение в провайдере темы(если пользователь принудительно не указал желаемую тему)
 * @returns null
 */
function useBrowserThemeDetector(props = {}) {
    const { enabled = true, onChange } = props;
    const [theme$1, setTheme] = useTheme.useTheme();
    const updateThemeInThemeProvider = React.useCallback(() => {
        const userTheme = cookies.get(consts.COOKIES.USER_THEME);
        const systemTheme = cookies.get(consts.COOKIES.SYSTEM_THEME);
        if (userTheme && isValidThemeName(userTheme))
            return;
        if (!systemTheme || !isValidThemeName(systemTheme))
            return;
        if (theme$1 === systemTheme)
            return;
        setTheme(systemTheme, false);
        onChange?.(systemTheme);
    }, [theme$1, setTheme, onChange]);
    const postMessageHandler = React.useCallback((event) => {
        const message = event.data;
        const { type, value } = message || {};
        if (typeof type === 'undefined' || type !== theme.postMessageType)
            return;
        if (typeof value === 'undefined' || !isValidThemeName(value))
            return;
        if (theme$1 === value)
            return;
        setTheme(value, false);
        onChange?.(value);
    }, [theme$1, setTheme, onChange]);
    // Проверка сразу после mount
    React.useEffect(() => {
        if (!enabled)
            return;
        if (!window.matchMedia)
            return;
        const isDarkTheme = window.matchMedia(darkThemeExpression).matches;
        setSystemCookie(isDarkTheme);
        updateThemeInThemeProvider();
    }, [enabled, updateThemeInThemeProvider]);
    // Подписываемся на изменения темы браузера
    React.useEffect(() => {
        if (!enabled)
            return;
        if (!window.matchMedia)
            return;
        window.matchMedia(darkThemeExpression).addEventListener('change', ({ matches: isDarkTheme }) => {
            setSystemCookie(isDarkTheme);
            updateThemeInThemeProvider();
        });
    }, [enabled, updateThemeInThemeProvider]);
    // Подписываемся на postMessage с новой темой(используется в iframe)
    React.useEffect(() => {
        if (!enabled)
            return;
        if (!window.addEventListener)
            return;
        window.addEventListener('message', postMessageHandler);
        return () => {
            window.removeEventListener('message', postMessageHandler);
        };
    }, [enabled, postMessageHandler, updateThemeInThemeProvider]);
    return null;
}

exports.useBrowserThemeDetector = useBrowserThemeDetector;
//# sourceMappingURL=useBrowserThemeDetector.js.map
